<template>
	<div class="page-content">
		<div class="inner-content">
			<!-- <p class="label main_color_text">Définitions</p> -->

			<section-map main_color="dark_grey" />
		</div>
	</div>
</template>

<script>
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import SectionMap from "@/components/study/editor/pages/sections/section-map";


export default {
	name: "page-map",
	mixins: [ PageMixin ],
	data: function () {
		return {
		};
	},
	props: [ "index" ],
	computed: {
	},
	methods: {
	},
	mounted: function () {
	},
	components: {
		SectionMap
	}
};
</script>
<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.td-cb
	min-width 120px
	width 60%

.td-price
	width 40%
</style>
